import { createSpaSetup } from '@fortem-monorepo/react-spa'

import { PERMISSIONS } from '@/constants/permissions'
import { FORTEM_URIS } from '@/constants/uris'

export const { createAction, createLink, createPopover, useUserContext, getUrl } = createSpaSetup({
  permissions: PERMISSIONS,
  uris: FORTEM_URIS,
})
